.text-align-right{text-align:right!important}
/*# sourceMappingURL=invoices.component-6F5MUA7R.css.map */
